import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { CallsRoute } from "./Calls";
import CallsQueryNode from "./__generated__/CallsQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof CallsRoute> = {
  root: JSResource("CallsRoute", () =>
    import("./Calls").then((module) => module.CallsRoute),
  ),
  getPreloadProps() {
    return {
      queries: {
        query: {
          parameters: CallsQueryNode,
          variables: {},
        },
      },
    };
  },
};

export default entryPoint;
